/**
 * 简单封装 XMLHttpRequest 请求
 */
type Method =
  | 'GET'
  | 'POST'
  | 'PUT'
  | 'PATCH'
  | 'DELETE'
  | 'HEAD'
  | 'OPTIONS'
  | 'get'
  | 'post'
  | 'put'
  | 'patch'
  | 'delete'
  | 'head'
  | 'options';

interface ProgressType {
  (arg: number): void;
}
interface RequestOptions {
  /** 请求方法 */
  method: Method;
  /** 请求头 */
  headers?: Record<string, string>;
  /** URL 地址 */
  url: string;
  /** 请求参数 */
  params?: Record<string, any>;
  /** 请求json数据 */
  json?: unknown;
  /** 请求fromData数据 */
  form?: Record<string, any>;
  /** 请求超时时间（单位：毫秒） */
  timeout?: number;
  /** 获取进度回调 */
  progressCallBack?: ProgressType;
}

const http = (options: RequestOptions) => {
  return new Promise(function (resolve, reject) {
    let queryString;
    if (options.params) {
      queryString = Object.keys(options.params)
        .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(options.params![k]))
        .join('&');
    }
    const url = queryString
      ? options.url + (options.url.indexOf('?') === -1 ? '?' : '&') + queryString
      : options.url;

    const xhr = new XMLHttpRequest();
    xhr.open(options.method, url);

    // 设置超时时间
    if (options.timeout && options.timeout > 0) {
      xhr.timeout = options.timeout;
    }

    xhr.onload = function onload() {
      if (this.status >= 200 && this.status < 300) {
        const data = JSON.parse(xhr.response);
        if (data.isError) {
          return reject({
            statusCode: this.status,
            ...data,
          });
        }
        return resolve('data' in data ? data.data : data);
      }
      return reject({
        statusCode: this.status,
        statusText: this.statusText,
      });
    };
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100;
        options.progressCallBack && options.progressCallBack(percentComplete);
      }
    };

    xhr.onerror = function onerror() {
      return reject({
        statusCode: this.status,
        statusText: this.statusText,
      });
    };

    let contentType;
    if (options.headers) {
      for (const key in options.headers) {
        xhr.setRequestHeader(key, options.headers[key]);
        if (key.toUpperCase() === 'CONTENT-TYPE') {
          contentType = options.headers![key];
        }
      }
    }

    if (options.json) {
      contentType || xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(options.json));
    } else if (options.form) {
      const formData = new FormData();
      for (const key in options.form) {
        const value = options.form[key];
        formData.append(key, value instanceof Array ? value.join(',') : value);
      }
      xhr.send(formData);
    } else {
      xhr.send();
    }
  });
};

export default http;
